var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.875 38V26.125H23.75V38H11.875ZM0 19.7917V18.2083H35.625V19.7917H0ZM11.875 11.875V0H23.75V11.875H11.875Z","fill":"#212121","style":{"fill":"color(display-p3 0.1294 0.1294 0.1294)","fillOpacity":"1"}}));
}

Icon.defaultProps = {"width":"36","height":"38","viewBox":"0 0 36 38","fill":"none"};

module.exports = Icon;

Icon.default = Icon;
